export default __webpack_public_path__ + "static/media/ico_stats.2daec0d9.svg";